import { createSlice } from '@reduxjs/toolkit';
import { Notification } from './models/notification.model';
import notificationService from '../services/notificationService';

interface NotificationState {
  loadingNotifications: boolean;
  loadedNotifications: boolean;
  notifications: Notification[];
}

export const initialState: NotificationState = {
  loadingNotifications: false,
  loadedNotifications: false,
  notifications: [],
};

export const slice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setLoadingNotifications: (
      state: NotificationState,
      action: { type: string; payload: boolean },
    ) => {
      state.loadingNotifications = action.payload;
    },
    setLoadedNotifications: (
      state: NotificationState,
      action: { type: string; payload: boolean },
    ) => {
      state.loadedNotifications = action.payload;
    },
    setNotifications: (
      state: NotificationState,
      action: { type: string; payload: Notification[] },
    ) => {
      state.notifications = action.payload;
    },
    addNotification: (
      state: NotificationState,
      action: { type: string; payload: Notification },
    ) => {
      state.notifications.push(action.payload);
    },
  },
});

export const { setLoadingNotifications } = slice.actions;
export const { setLoadedNotifications } = slice.actions;
export const { setNotifications } = slice.actions;
export const { addNotification } = slice.actions;

export const fetchNotificationsAsync = () => (dispatch: Function) => {
  dispatch(setLoadingNotifications(true));
  dispatch(setLoadedNotifications(false));
  notificationService.getNotifications().subscribe((notifications) => {
    dispatch(setLoadedNotifications(true));
    dispatch(setLoadingNotifications(false));
    dispatch(setNotifications(notifications));
  });
};

export const fetchNotificationAsync = (id: string) => (dispatch: Function) => {
  notificationService.getNotification(id).subscribe({
    next: (notification) => {
      dispatch(addNotification(notification));
    },
    // error: (err) => {
    // },
  });
};

export const dismissNotificationAsync =
  (id: number) => (dispatch: Function) => {
    dispatch(setLoadingNotifications(true));
    dispatch(setLoadedNotifications(false));
    notificationService.dismissNotification(id).subscribe(() => {
      dispatch(fetchNotificationsAsync());
    });
  };

export const selectLoadingNotifications = (state: {
  notification: NotificationState;
}) => state.notification.loadingNotifications;
export const selectLoadedNotifications = (state: {
  notification: NotificationState;
}) => state.notification.loadedNotifications;
export const selectNotifications = (state: {
  notification: NotificationState;
}) => {
  return state.notification.notifications;
};

export default slice.reducer;
